import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Paths that must NOT be indexed (private / authenticated / system pages).
const PRIVATE_PREFIXES = [
  "/admin", "/my-learning", "/learn", "/login", "/register",
  "/forgot-password", "/reset-password", "/auth", "/payment",
];

// Per-route titles/descriptions for the core public pages (SEO improvement).
const ROUTE_META = {
  "/": {
    title: "Epic Fade Academy — Premium Barber Education",
    desc: "Premium, cinematic barber education. Master fades, tapers, beard work and the business of barbering.",
  },
  "/store": {
    title: "Courses — Epic Fade Academy",
    desc: "Browse premium barber courses on fades, tapers, beard work and more, taught by industry masters.",
  },
  "/portfolio": {
    title: "My Work — Epic Fade Academy",
    desc: "A portfolio of premium fades, tapers and finished barber work from Epic Fade Academy.",
  },
  "/community": {
    title: "Community — Epic Fade Academy",
    desc: "Join the Epic Fade Academy community of barbers growing their craft and their business.",
  },
};

function upsert(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
  return el;
}

export function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const origin = window.location.origin.replace(/^http:/, "https:");
    const canonicalUrl = `${origin}${pathname}`;
    const isPrivate = PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

    upsert('meta[name="robots"]',
      () => { const m = document.createElement("meta"); m.setAttribute("name", "robots"); return m; },
      "content", isPrivate ? "noindex, nofollow" : "index, follow");

    upsert('link[rel="canonical"]',
      () => { const l = document.createElement("link"); l.setAttribute("rel", "canonical"); return l; },
      "href", canonicalUrl);

    upsert('meta[property="og:url"]',
      () => { const m = document.createElement("meta"); m.setAttribute("property", "og:url"); return m; },
      "content", canonicalUrl);

    const meta = ROUTE_META[pathname];
    if (meta) {
      document.title = meta.title;
      upsert('meta[name="description"]',
        () => { const m = document.createElement("meta"); m.setAttribute("name", "description"); return m; },
        "content", meta.desc);
      upsert('meta[property="og:title"]',
        () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; },
        "content", meta.title);
      upsert('meta[property="og:description"]',
        () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; },
        "content", meta.desc);
    }
  }, [pathname]);
  return null;
}
